import React, { Component } from 'react';
import './../css/master.css';
import './../css/wvrProgressUpdate.css';
import WeaverHeader from './../js/weaverHeader.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';
import DatePicker from 'react-datepicker';
//import moment from 'moment';
import FailPass from './switch.js';

var httpURL = '';
var queryString = require('querystring');
var lstYardage = [];
var lstConstruction = [];

class WVRProgressUpdate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			flg: true,
			designImagePath: require('./../images/blank.png'),
			loader: 'none',
			opacity: 1,
			checked1: false,
			checked2: false,
			checked3: false,
			checked4: false,
			checked5: false,
			checked6: false,
			checked7: false,
			checked8: false,
			checked9: false,
			checked10: false,
			checked11: false,
			checked12: false,
			yardage: [],
			yardageDate: '',
			deskloomDate: '',
			disabledDeskloomDt: false,
			disabledDeskloomBtn: false,
			disabledWvrDryRubbing: false,
			disabledWvrWetRubbing: false,
			disabledWvrWashing: false,
			disabledWvrWetWashing: false,
			disabledWvrStaining: false,
			disabledWvrWarpShrinkageFP: false,
			disabledYardageDt: false,
			disabledYardageBtn: false,
			disabledQCDone: false,
			disabledWvrWarpShrinkage: false,
			disabledWvrWeftShrinkage: false,
			disabledWvrConstructions: false,
			progressId: 0,
			progress1: '',
			progress2: '',
			progress3: '',
		}
	}

	handleChange1 = (e) => {
		this.setState({
			checked1: e,
		});
	}
	handleChange3 = (e) => {
		this.setState({
			checked3: e,
		});
	}
	handleChange5 = (e) => {
		this.setState({
			checked5: e,
		});
	}
	handleChange7 = (e) => {
		this.setState({
			checked7: e,
		});
	}
	handleChange9 = (e) => {
		this.setState({
			checked9: e,
		});
	}
	handleChange11 = (e) => {
		this.setState({
			checked11: e,
		});
	}
	handleDeskloom = (e) => {
		this.setState({
			deskloomDate: e,
		});
	}
	handleYardage = (e) => {
		this.setState({
			yardageDate: e,
		});
	}
	handleProgress1 = (e) => {
		this.setState({
			progress1: e,
		});
	}
	handleProgress2 = (e) => {
		this.setState({
			progress2: e,
		});
	}
	handleProgress3 = (e) => {
		this.setState({
			progress3: e,
		});
	}

	async componentDidMount() {
		await axiosInstance.get(httpURL + '/a/mst/cons/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstConstruction = response.data.lstConstruction;
				this.fillConstructionCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		var details = this.props.location.state.detail;
		$('#ipoId').val(details.ipoId);
		$('#ipoNo').val(details.ipoNo);
		$('#ipoDesignId').val(details.ipoDesignId);
		$('#designId').val(details.designId);
		$('#designNoColor').val(details.designNoColor);
		$('#quality').val(details.quality);
		$('#length').val(details.length);
		$('#width').val(details.width);
		$('#yarnCount').val(details.yarnCount);
		$('#construction').val(details.construction);

		var deskloom = {};
		var ipoDesignId = $('#ipoDesignId').val();
		deskloom = { ipoDesignId };

		this.setState({ loader: 'block', opacity: 0.5, designImagePath: details.imageUrl });

		axiosInstance.post(httpURL + '/w/po/prog/listdeskloom',
			queryString.stringify({ 'deskloom': JSON.stringify(deskloom) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				$('#deskloomStatus').html(response.data.lstDeskLoom[0].deskLoomStatus);

				if (response.data.lstDeskLoom[0].deskLoomStatusId == 2) {
					this.setState({
						disabledDeskloomDt: true,
						disabledDeskloomBtn: true,
					});
				} else {
					this.setState({
						disabledDeskloomDt: false,
						disabledDeskloomBtn: false,
					})
				}

				if (response.data.lstDeskLoom[0].deskLoomDt == '') {
					this.setState({
						deskloomDate: null,
					});
				} else {
					var date = response.data.lstDeskLoom[0].deskLoomDt;
					date = date.split('-');
					var setDate = date.reverse().join();
					setDate = setDate.replace(/,/g, '-');
					var deskloomDt = new Date(setDate);
					this.setState({
						deskloomDate: deskloomDt,
					});
				}
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		this.yardage();
		this.progress();
	}

	fillConstructionCmb() {
		$('.constructionCmb').empty();
		$('.constructionCmb').prepend($("<option> </option>").val(0).html('Construction'));
		for (var i = 0; i < lstConstruction.length; i++) {
			var constructionId = lstConstruction[i].constructionId;
			var construction = lstConstruction[i].construction;
			$('.constructionCmb').append($("<option> </option>").val(constructionId).html(construction));
		}
	}

	yardage = () => {
		var ipoDesignId = $('#ipoDesignId').val();
		var deskloom = { ipoDesignId };
		axiosInstance.post(httpURL + '/w/po/prog/listyardage',
			queryString.stringify({ 'yardage': JSON.stringify(deskloom) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					yardage: response.data.lstYardage,
				})
				lstYardage = this.state.yardage;
				this.setYardageData();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	progress = () => {
		var ipoDesignId = $('#ipoDesignId').val();
		var deskloom = { ipoDesignId };
		axiosInstance.post(httpURL + '/w/po/prog/listprogress',
			queryString.stringify({ 'progress': JSON.stringify(deskloom) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					progressId: response.data.lstProgress[0].progressId,
				});

				if (response.data.lstProgress[0].progress1 == '' || response.data.lstProgress[0].progress1 == '00-00-0000') {
					this.setState({
						progress1: null,
					});
				} else {
					var date = response.data.lstProgress[0].progress1;
					date = date.split('-');
					var setDate = date.reverse().join();
					setDate = setDate.replace(/,/g, '-');
					var progress1Dt = new Date(setDate);
					this.setState({
						progress1: progress1Dt,
					});
				}

				if (response.data.lstProgress[0].progress2 == '' || response.data.lstProgress[0].progress2 == '00-00-0000') {
					this.setState({
						progress2: null,
					});
				} else {
					var date = response.data.lstProgress[0].progress2;
					date = date.split('-');
					var setDate = date.reverse().join();
					setDate = setDate.replace(/,/g, '-');
					var progress2Dt = new Date(setDate);
					this.setState({
						progress2: progress2Dt,
					});
				}

				if (response.data.lstProgress[0].progress3 == '' || response.data.lstProgress[0].progress3 == '00-00-0000') {
					this.setState({
						progress3: null,
					});
				} else {
					var date = response.data.lstProgress[0].progress3;
					date = date.split('-');
					var setDate = date.reverse().join();
					setDate = setDate.replace(/,/g, '-');
					var progress3Dt = new Date(setDate);
					this.setState({
						progress3: progress3Dt,
					});
				}
				$('#progressStatus').val(response.data.lstProgress[0].progressStatusId);
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	saveDeskloom = () => {
		var deskloom = {};
		var ipoDesignId = $('#ipoDesignId').val();
		var deskLoomDt = $('#deskloomDt').val();

		if (deskLoomDt == '') {
			toast.warning('Please fill deskloom date');
			return false;
		}
		deskloom = { ipoDesignId, deskLoomDt };
		this.setState({ loader: 'block', opacity: 0.5 });

		axiosInstance.post(httpURL + '/w/po/prog/savedeskloom',
			queryString.stringify({ 'deskloom': JSON.stringify(deskloom) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				toast.success(response.data.SvcMsg);
				$('#deskloomStatus').html("PENDING");
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setYardageData = () => {
		$('#QCDone').prop('checked', lstYardage[0].qcByWeaver);
		$('#internalQC').val(lstYardage[0].iqcYardageStatusId);
		$('#externalQC').val(lstYardage[0].eqcYardageStatusId);
		$('#reportNo').val(lstYardage[0].reportNo);

		if (lstYardage[0].yardageDt == '') {
			this.setState({
				yardageDate: null,
			});
		} else {
			var date = lstYardage[0].yardageDt;
			date = date.split('-');
			var setDate = date.reverse().join();
			setDate = setDate.replace(/,/g, '-');
			var yardageDt = new Date(setDate);
			this.setState({
				yardageDate: yardageDt,
			});
		}

		this.setState({
			checked1: lstYardage[0].wvrCfrDry == 1 ? true : false,
			checked2: lstYardage[0].cfrDry == 1 ? true : false,
			checked3: lstYardage[0].wvrCfrWet == 1 ? true : false,
			checked4: lstYardage[0].cfrWet == 1 ? true : false,
			checked6: lstYardage[0].cfw == 1 ? true : false,
			checked5: lstYardage[0].wvrCfw == 1 ? true : false,
			checked9: lstYardage[0].wvrStnCotton == 1 ? true : false,
			checked10: lstYardage[0].stnCotton == 1 ? true : false,
			checked11: lstYardage[0].wvrShrinkage == 1 ? true : false,
			checked12: lstYardage[0].shrinkage == 1 ? true : false,
		})
		$('#wvrWarpShrinkage').val(lstYardage[0].wvrWarpShrinkagePerc);
		$('#csWarpShrinkage').val(lstYardage[0].warpShrinkagePerc);
		$('#wvrWeftShrinkage').val(lstYardage[0].wvrWeftShrinkagePerc);
		$('#csWeftShrinkage').val(lstYardage[0].weftShrinkagePerc);
		$('#wvrConstructions').val(lstYardage[0].wvrConstructionId);
		$('#csConstructions').val(lstYardage[0].constructionId);

		if (lstYardage[0].iqcYardageStatusId == 2 && (lstYardage[0].eqcYardageStatusId == 4 || lstYardage[0].eqcYardageStatusId == 2)) {
			this.setState({
				disabledWvrDryRubbing: true,
				disabledWvrWetRubbing: true,
				disabledWvrWashing: true,
				disabledWvrWetWashing: true,
				disabledWvrStaining: true,
				disabledWvrWarpShrinkageFP: true,
				disabledYardageDt: true,
				disabledYardageBtn: true,
				disabledQCDone: true,
				disabledWvrWarpShrinkage: true,
				disabledWvrWeftShrinkage: true,
				disabledWvrConstructions: true
			});
		}
		else {
			this.setState({
				disabledWvrDryRubbing: false,
				disabledWvrWetRubbing: false,
				disabledWvrWashing: false,
				disabledWvrWetWashing: false,
				disabledWvrStaining: false,
				disabledWvrWarpShrinkageFP: false,
				disabledYardageDt: false,
				disabledYardageBtn: false,
				disabledQCDone: false,
				disabledWvrWarpShrinkage: false,
				disabledWvrWeftShrinkage: false,
				disabledWvrConstructions: false
			});
		}
	}

	saveYardage = () => {
		var yardage = {};
		var ipoDesignId = $('#ipoDesignId').val();
		var yardageDt = $('#yardageDate').val();
		var qcByWeaver = $('#QCDone').is(':checked') == true ? 1 : 0;
		var wvrCfrDry = this.state.checked1 == true ? 1 : 2;
		var wvrCfrWet = this.state.checked3 == true ? 1 : 2;
		var wvrCfw = this.state.checked5 == true ? 1 : 2;
		var wvrStnCotton = this.state.checked9 == true ? 1 : 2;
		var wvrShrinkage = this.state.checked11 == true ? 1 : 2;
		var wvrWarpShrinkagePerc = $('#wvrWarpShrinkage').val();
		var wvrWeftShrinkagePerc = $('#wvrWeftShrinkage').val();
		var wvrConstructionId = $('#wvrConstructions').find('option:selected').val();

		if (yardageDt == '') {
			toast.warning('Please fill yardage date');
			return false;
		}

		yardage = { ipoDesignId, yardageDt, qcByWeaver, wvrCfrDry, wvrCfrWet, wvrCfw, wvrStnCotton, wvrShrinkage, wvrWarpShrinkagePerc, wvrWeftShrinkagePerc, wvrConstructionId };
		this.setState({ loader: 'block', opacity: 0.5 });

		axiosInstance.post(httpURL + '/w/po/prog/saveyardage',
			queryString.stringify({ 'yardage': JSON.stringify(yardage) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				toast.success(response.data.SvcMsg);
				$('#internalQC').val(1);

				if ($('#externalQC').val() != 4) {
					$('#externalQC').val(1);
				}
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	saveProgress = () => {
		var progress = {};
		var ipoDesignId = $('#ipoDesignId').val();
		var progressId = this.state.progressId;
		var progressStatusId = $('#progressStatus').find('option:selected').val();
		var progress1 = $('#progress1').val();
		var progress2 = $('#progress2').val();
		var progress3 = $('#progress3').val();

		if (progress1 == '') {
			toast.warning('Please fill 25% date');
			document.getElementById('progress1').focus();
			return false;
		}

		progress = { ipoDesignId, progressId, progressStatusId, progress1, progress2, progress3 };
		this.setState({ loader: 'block', opacity: 0.5 });

		axiosInstance.post(httpURL + '/w/po/prog/saveprogress',
			queryString.stringify({ 'progress': JSON.stringify(progress) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				toast.success(response.data.SvcMsg);
				this.setState({
					progressId: response.data.progressId,
				});
				$('#progressStatus').val(response.data.progressStatusId);
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<WeaverHeader />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader, zIndex: 9999 }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main" style={{ opacity: this.state.opacity }}>
					<div className="container-fluid">
						<div className="col-sm-12 col-centered">
							<div className="row">
								<div className="col-sm-10" style={{ paddingLeft: 0 }}>
									<div className="styleBackground">
										<form className="form-inline">
											<div className="form-group">
												<label style={{ width: 60 }} htmlFor="ipoNo">IPO NO:</label>
												<input style={{ display: 'none' }} placeholder="IPO Id" type="text" className="form-control" id="ipoId" />
												<input style={{ display: 'none' }} placeholder="IPO Design Id" type="text" className="form-control" id="ipoDesignId" />
												<input style={{ marginLeft: 5 }} readOnly placeholder="IPO Number" type="text" className="form-control" id="ipoNo" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="designNoColor">Design Color:</label>
												<input style={{ display: 'none' }} placeholder="Design Id" type="text" className="form-control" id="designId" />
												<input style={{ marginLeft: 5 }} readOnly placeholder="Design Color" type="text" className="form-control" id="designNoColor" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 60 }} htmlFor="quality">Quality:</label>
												<input style={{ marginLeft: 5 }} readOnly placeholder="Quality" type="text" className="form-control" id="quality" />
											</div>
										</form>
										<form className="form-inline" style={{ marginTop: 5 }}>
											<div className="form-group">
												<label style={{ marginLeft: 0, width: 60 }} htmlFor="width">Width:</label>
												<input style={{ marginLeft: 5 }} readOnly placeholder="Width" type="text" className="form-control" id="width" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="yarnCount">Yarn Count:</label>
												<input style={{ marginLeft: 5 }} readOnly placeholder="Yarn Count" type="text" className="form-control" id="yarnCount" />
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 60 }} htmlFor="length">Length:</label>
												<input style={{ marginLeft: 5, width: 100 }} readOnly placeholder="Length" type="text" className="form-control text-right" id="length" />
											</div>

											<div className="form-group">
												<label style={{ marginLeft: 10 }} htmlFor="construction">Construction:</label>
												<input style={{ marginLeft: 5, width: 100 }} readOnly placeholder="Construction" type="text" className="form-control" id="construction" />
											</div>
										</form>
									</div>
									<div style={{ marginTop: 5, display: 'flex', flexDirection: 'row', position: 'relative' }} className="styleBackground">
										<h4 style={{ fontWeight: 'bold', color: '#bb592b', width: 130 }}>Deskloom</h4>
										<form className="form-inline">
											<div className="form-group">
												<label style={{ width: 120 }} htmlFor="deskloomDt">Deskloom Date:<span style={{ color: 'red' }}>*</span></label>
												<div style={{ display: 'inline-block', marginLeft: 2, width: 133.5 }}>
													<DatePicker id="deskloomDt"
														className='form-control inline-width text-center'
														placeholderText="Deskloom Date"
														selected={this.state.deskloomDate}
														onChange={this.handleDeskloom}
														dateFormat="dd-MM-yyyy"
														autoComplete='off'
														disabled={this.state.disabledDeskloomDt}
													/>
												</div>
											</div>
											<button disabled={this.state.disabledDeskloomBtn} style={{ marginLeft: 40 }} onClick={this.saveDeskloom} type="button" className="btn btn-warning">Save</button>
											<div style={{ position: 'absolute', right: 20, top: 14 }}>
												<label>Status:</label>
												<span id="deskloomStatus" style={{ fontSize: 11.5, marginLeft: 10 }}></span>
											</div>
										</form>
									</div>
								</div>
								<div className="col-sm-2 padding-remove" id="designColorImageDiv3">
									<ReactImageMagnify {...{
										smallImage: {
											alt: 'Design Image',
											src: this.state.designImagePath,
											isFluidWidth: true,
										},
										largeImage: {
											src: this.state.designImagePath,
											width: 600,
											height: 900
										},
										enlargedImageContainerDimensions: {
											width: 300,
											height: 300,
										},
										enlargedImageContainerStyle: {
											left: -170,
											top: 140,
										},
									}} />
								</div>
							</div>
							<div className="row styleBackground" style={{ position: 'relative', marginTop: 5, display: 'flex', flexDirection: 'row', height: 370 }}>
								<div style={{ display: 'flex', flexDirection: 'row', borderRight: '2px solid rgb(231,231,231)', paddingRight: 10 }}>
									<h4 style={{ fontWeight: 'bold', color: '#bb592b', width: 130 }}>PP Yardage</h4>
									<div>
										<form className="form-inline">
											<div className="form-group">
												<label style={{ width: 120 }} htmlFor="yardageDate">Yardage Date:<span style={{ color: 'red' }}>*</span></label>
												<div style={{ display: 'inline-block', marginLeft: 2, width: 133.5 }}>
													<DatePicker id="yardageDate"
														className='form-control inline-width text-center'
														placeholderText="Yardage Date"
														selected={this.state.yardageDate}
														onChange={this.handleYardage}
														dateFormat="dd-MM-yyyy"
														autoComplete='off'
														disabled={this.state.disabledYardageDt}
													/>
												</div>
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="QCDone">QC Done:</label>
												<div className="checkbox">
													<input disabled={this.state.disabledQCDone} type="checkbox" id="QCDone" />
												</div>
											</div>
											<div className="form-group pull-right">
												<span onClick={this.yardage} title="Refresh" style={{ fontSize: 20, paddingLeft: 10, cursor: 'pointer' }} className="glyphicon glyphicon-refresh"></span>
											</div>
										</form>
										<form className="form-inline" style={{ marginTop: 5 }}>
											<div className="form-group">
												<label style={{ width: 120 }} htmlFor="internalQC">Internal QC:</label>
												<select disabled style={{ marginLeft: 2, fontSize: 11.5, width: 133.5 }} className="form-control" id="internalQC">
													<option value="0">PENDING</option>
													<option value="1">PENDING BY CS</option>
													<option value="2">APPROVED BY CS</option>
													<option value="3">REJECTED BY CS</option>
												</select>
											</div>
											<div className="form-group">
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="externalQC">External QC:</label>
												<select disabled style={{ marginLeft: 2, fontSize: 11.5, width: 133.5 }} className="form-control" id="externalQC">
													<option value="4">N/A</option>
													<option value="0">PENDING</option>
													<option value="1">PENDING BY CS</option>
													<option value="2">APPROVED BY CS</option>
													<option value="3">REJECTED BY CS</option>
												</select>
											</div>
											<div className="form-group" id="reportDiv" style={{ display: 'none' }}>
												<label style={{ marginLeft: 10, width: 100 }} htmlFor="reportNo">Report No:</label>
												<input style={{ marginLeft: 2, width: 120 }} placeholder="Report Number" type="text" className="form-control" id="reportNo" />
											</div>
										</form>
										<div style={{ marginTop: 10, display: 'flex', flexDirection: 'row' }}>
											<table style={{ width: 500 }}>
												<thead>
													<tr>
														<th className="text-center" style={{ width: 200 }}>Process</th>
														<th colSpan={2} style={{ width: 20 }}>Weaver</th>
														<th colSpan={2} style={{ width: 20 }}>Chandra Silk</th>
													</tr>
												</thead>
												<tbody id="yardageTbody">
													<tr>
														<td>Color fastness to rubbing (DRY)</td>
														<td colSpan={2}><FailPass disabled={this.state.disabledWvrDryRubbing} handleChange={this.handleChange1} checked={this.state.checked1} id="wvrDryRubbing" /></td>
														<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange2} checked={this.state.checked2} id="csDryRubbing" /></td>
													</tr>
													<tr>
														<td>Color fastness to rubbing (WET)</td>
														<td colSpan={2}><FailPass disabled={this.state.disabledWvrWetRubbing} handleChange={this.handleChange3} checked={this.state.checked3} id="wvrWetRubbing" /></td>
														<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange4} checked={this.state.checked4} id="csWetRubbing" /></td>
													</tr>
													<tr>
														<td>Color fastness to washing</td>
														<td colSpan={2}><FailPass disabled={this.state.disabledWvrWashing} handleChange={this.handleChange5} checked={this.state.checked5} id="wvrDryWashing" /></td>
														<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange6} checked={this.state.checked6} id="csDryWashing" /></td>
													</tr>
													<tr>
														<td>Staining on cotton</td>
														<td colSpan={2}><FailPass disabled={this.state.disabledWvrStaining} handleChange={this.handleChange9} checked={this.state.checked9} id="wvrStaining" /></td>
														<td colSpan={2}><FailPass disabled={true} handleChange={this.handleChange10} checked={this.state.checked10} id="csStaining" /></td>
													</tr>
													<tr>
														<td>Warp Shrinkage</td>
														<td>
															<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
																<input disabled={this.state.disabledWvrWarpShrinkage} className="form-control text-right" type="text" id="wvrWarpShrinkage" />
																<span style={{ fontSize: 14 }}>%</span>
															</div>
														</td>
														<td rowSpan={2}>
															<FailPass disabled={this.state.disabledWvrWarpShrinkageFP} handleChange={this.handleChange11} checked={this.state.checked11} id="wvrWarpShrinkageFP" />
														</td>
														<td>
															<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
																<input disabled style={{ width: 50, float: 'left' }} className="form-control text-right" type="text" id="csWarpShrinkage" />
																<span style={{ fontSize: 14, float: 'left' }}>%</span>
															</div>
														</td>
														<td rowSpan={2}>
															<FailPass disabled={true} handleChange={this.handleChange12} checked={this.state.checked12} id="csWarpShrinkageFP" />
														</td>
													</tr>
													<tr>
														<td>Weft Shrinkage</td>
														<td>
															<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
																<input disabled={this.state.disabledWvrWeftShrinkage} style={{ width: 50, float: 'left' }} className="form-control text-right" type="text" id="wvrWeftShrinkage" />
																<span style={{ fontSize: 14, float: 'left' }}>%</span>
															</div>
														</td>
														<td>
															<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
																<input disabled style={{ width: 50, float: 'left' }} className="form-control text-right" type="text" id="csWeftShrinkage" />
																<span style={{ fontSize: 14, float: 'left' }}>%</span>
															</div>
														</td>
													</tr>
													<tr>
														<td>Constructions (Read/Pick)</td>
														<td colSpan={2}><select disabled={this.state.disabledWvrConstructions} className="constructionCmb form-control" id="wvrConstructions"></select></td>
														<td colSpan={2}><select disabled className="constructionCmb form-control" id="csConstructions"></select></td>
													</tr>
												</tbody>
											</table>
											<div style={{ width: 108, position: 'relative' }}>
												<button disabled={this.state.disabledYardageBtn} style={{ position: 'absolute', bottom: 0, right: 0 }} onClick={this.saveYardage} type="button" className="btn btn-warning">Save</button>
											</div>
										</div>
									</div>
								</div>
								<div style={{ paddingLeft: 10 }} className="col-centered">
									<h4 style={{ marginLeft: -125, fontWeight: 'bold', color: '#bb592b', width: 130 }}>Progress</h4>
									<span onClick={this.progress} title="Refresh" style={{ position: 'absolute', right: 10, top: 5, fontSize: 20, paddingLeft: 10, cursor: 'pointer' }} className="glyphicon glyphicon-refresh"></span>
									<form id="progressForm" className="form-horizontal styleBackground" style={{ padding: 20 }}>
										<div className="form-group">
											<label htmlFor="progress1" className="control-label col-sm-6">25%:<span style={{ color: 'red' }}>*</span></label>
											<div className="col-sm-6">
												<DatePicker id="progress1"
													className='form-control'
													placeholderText="25%"
													selected={this.state.progress1}
													onChange={this.handleProgress1}
													dateFormat="dd-MM-yyyy"
													autoComplete='off'
												/>
											</div>
										</div>
										<div className="form-group">
											<label className="control-label col-sm-6" htmlFor="progress2">50%:</label>
											<div className="col-sm-6">
												<DatePicker id="progress2"
													className='form-control'
													placeholderText="50%"
													selected={this.state.progress2}
													onChange={this.handleProgress2}
													dateFormat="dd-MM-yyyy"
													autoComplete='off'
												/>
											</div>
										</div>
										<div className="form-group">
											<label className="control-label col-sm-6" htmlFor="progress3">100%:</label>
											<div className="col-sm-6">
												<DatePicker id="progress3"
													className='form-control'
													placeholderText="100%"
													selected={this.state.progress3}
													onChange={this.handleProgress3}
													dateFormat="dd-MM-yyyy"
													autoComplete='off'
												/>
											</div>
										</div>
										<div className="form-group text-center">
											<button style={{ marginTop: 20 }} onClick={this.saveProgress} type="button" className="btn btn-warning">Save</button>
										</div>
									</form>
									<div style={{ display: 'flex', flexDirection: 'row', marginTop: 10 }}>
										<label style={{ paddingTop: 6 }}>Status by CS:</label>
										<select disabled style={{ marginLeft: 2, width: 120 }} className="form-control" id="progressStatus">
											<option value="1">PENDING</option>
											<option value="2">APPROVED</option>
											<option value="3">REJECTED</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default WVRProgressUpdate;
